<template>
  <div class="sidemenu__wrap">
    <div class="sidemenu__close-wrap">
      <span @click="handleClick">Stäng <icon fill="white" type="times"></icon></span>
    </div>
    <div class="sidemenu__link-wrap">
      <span @click="handleClick">
        <router-link to="/arbetsgivarinformation">
        Att anställa asylsökande och nyanlända
        </router-link>
      </span>
    </div>
    <div class="sidemenu__link-wrap">
      <span @click="handleClick">
        <router-link to="/om-jobskills">
        Om Jobskills
        </router-link>
      </span>
    </div>
    <div class="sidemenu__link-bottom">
      <a :href="jobskillsURL"><icon link type="angle-right"></icon> Gå till Jobskills för arbetssökande</a>
    </div>
    <div class="sidemenu__link-bottom">
      <span @click="handleClick">
        <router-link
        to="/kontakta-oss"
        class="sidemenu__link-bottom-phone"><icon link type="phone"></icon> Kontakt</router-link>
      </span>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'af-sidemenu',
  components: {
    Icon
  },
  data() {
    return {
      jobskillsURL: window.__JOBSKILLS_URL__
    }
  },
  methods: {
    handleClick() {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="postcss" scoped>
.sidemenu__wrap {
  background-color: var(--color-porcelain);
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.36);
  height: 100%;
}

.sidemenu__close-wrap {
  background-color: var(--color-matisse);
  color: var(--color-white);
  display: flex;
  justify-content: flex-end;
  height: 100px;
  padding: var(--spacing-medium) var(--spacing-medium) 0 0;
}

.sidemenu__link-wrap {
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-alto);
  padding: var(--spacing-medium);

  & a {
    color: var(--color-mine-shaft);
    text-decoration: none;
  }
}

.sidemenu__link-bottom {
  padding: var(--spacing-medium);

  & a {
    display: flex;
    text-decoration: none;
  }

  & .sidemenu__link-bottom-phone {
    display: flex;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AfSidemenu.vue